import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import style from "./style.module.scss";

const SolutionControlMenu = ({ path }) => {
	const { t } = useTranslation();

	return (
		<div className={style.root}>
			<h2 className={style.title}>
				{t("access.menus.controlSolution.title")}
			</h2>
			<p>{t("access.menus.controlSolution.description")}</p>
			<Link className={style.link} to={`${path}/exploitation/devices`}>
				{t("access.menus.controlSolution.discover")}
			</Link>
		</div>
	);
};

SolutionControlMenu.propTypes = {
	path: PropTypes.string.isRequired
};

export default SolutionControlMenu;
